import {Navigate, useLocation} from "react-router-dom";
import {resolveLegacyPath} from "@/lib/paths";
import {NotFoundPage} from "@/pages/NotFoundPage";

export function LegacyOrNotFoundPage() {
  const {pathname, search} = useLocation();
  const target = resolveLegacyPath(pathname);
  if(target) return <Navigate to={`${target}${search}`} replace />;
  return <NotFoundPage />;
}
